module.exports = __webpack_public_path__ + "img/s1@2x.8d32c700.png";